import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=f87d67e0"
import script from "./TagIcon.vue?vue&type=script&lang=ts"
export * from "./TagIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports